import QRCode from 'qrcode';
import { Modal, message, Input, Spin } from 'antd';
import './ShareModal.scss';
import { useEffect } from 'react';
export default function ShareModal(props) {
    const {
        copyUrl = 'https://www.baidu.com',
        title = '分享全景图',
        copySuccessMessage = '复制成功，粘贴至微信或QQ即可分享！',
    } = props;
    const [codeImgUrl, setCodeImgUrl] = useState('');
    function getCodeUrl(url) {
        QRCode.toDataURL(url, { margin: 0 }, (err, code) => {
            if (err) throw err;
            setCodeImgUrl(code);
            console.log(code, 'code');
        });
    }

    useEffect(() => {
        if (!copyUrl) return;
        getCodeUrl(copyUrl);
    }, [copyUrl]);

    const { isModalOpen, setIsModalOpen } = props;

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const copyInput = useRef();
    // 两种方式复制到剪切板
    const copyLink = async () => {
        if (!copyUrl) return;
        const { clipboard } = navigator;
        try {
            if (!clipboard) throw new Error();
            await clipboard.writeText(copyUrl);
        } catch {
            copyInput.current.select();
            document.execCommand('copy');
        } finally {
            message.success(copySuccessMessage);
        }
    };

    return (
        <>
            <Modal
                title={title}
                destroyOnClose
                width={320}
                visible={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                wrapClassName="share-modal"
                footer={null}>
                <Spin spinning={props.loading}>
                    <div className="copy-input">
                        <Input
                            ref={copyInput}
                            addonAfter={<span onClick={copyLink}>复制</span>}
                            value={copyUrl}
                            readOnly
                        />
                    </div>
                    <div className="code-img">
                        <img src={codeImgUrl} />
                    </div>
                    <div className="expire">
                        该分享一年内（{props.expire}前）有效
                    </div>
                </Spin>
            </Modal>
        </>
    );
}
